import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

// SillType — parent control; shows/hides children based on selection
// Standard: show SillFinish (ClearAnodized/BlackAnodized), SillSize, SillHorn
// Handicap: show SillFinish (Mill), SillSize; hide SillHorn
const OPTIONS = [
  { value: 'Standard', label: 'Standard' },
  { value: 'Handicap', label: 'Handicap' },
];

const SillType = ({
  value = { value: '', label: '' },
  onChange,
  disabled = false,
  onSillChildrenVisible,  // (show, showHorn) — notifies panel which children to display
}) => {
  const [selected, setSelected] = useState(value?.value || '');

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });
    // notify parent: show children whenever a type is selected; hide SillHorn for Handicap
    const show = v === 'Standard' || v === 'Handicap';
    const showHorn = v === 'Standard';
    onSillChildrenVisible?.(show, showHorn);
  };

  return (
    <div className="a-container">
      <label htmlFor="SdSillType">Sill Type</label>
      <select id="SdSillType" value={selected} onChange={handleChange} disabled={disabled}>
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SillType;
